import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileMeetingsController } from 'presentation/page/profile/coachee-profile/coachee-profile-meetings/coachee-profile-meetings.controller';

@Component({
	selector: 'spr-coachee-profile-meetings-filter',
	templateUrl: './coachee-profile-meetings-filter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'flex md:flex-none md:items-center bg-grey-alabaster md:p-3 px-1 py-3 md:space-x-3 md:flex-row flex-col md:space-y-0 space-y-3',
	},
})
export class CoacheeProfileMeetingsFilterComponent {
	constructor(public controller: CoacheeProfileMeetingsController) {}

	public onDateSortClick() {
		this.controller.toggleDateSort();
	}

	public onAddMeetingsExportClick() {
		this.controller.addMeetingsExport();
	}
}
